export enum WarningTheme {
  Default = `default`,
  Error = `error`,
  /**
   * Permission errors related to sensitive data
   */
  Sensitive = `sensitive`,
  /**
   * Small message, usually suggesting an action
   */
  NoIcon = `no-icon`,
  /**
   * Report did the query, but returned no results
   */
  NoData = `no-data`,
  /**
   * Shows the loading spinner
   */
  Loading = `loading`,

  /**
   * Adds styles for properly displaying a Mixpanel Tip
   */
  Tip = `tip`,
}
